import axios from 'axios';
import { getLocalData, removeLocalData, setLocalData } from './helper'

const BASE_URL = window._env_.APP_BASE_URL + window._env_.APP_API_VERSION;
axios.defaults.baseURL = BASE_URL
axios.defaults.withCredentials = true
let refreshPromise = null;

export default class WebService {


    static async post(action, params, config) {
        let response = await axios.post(action, params, config)
        return response.data
    }
    static async put(action, params) {
        let response = await axios.put(action, params)
        return response.data
    }
    static async get(action, config) {
        let response = await axios.get(action, config)
        return response.data
    }
    static async delete(action) {
        let response = await axios.delete(action)
        return response.data
    }
    static async patch(action, params) {
        let response = await axios.patch(action, params)
        return response.data
    }


}

axios.interceptors.request.use(async (config) => {
    // Do something before request is sent
    config.baseURL = BASE_URL;
    const token = await getLocalData("token");
    if (!config.skipAuth) {
        config.headers.common['Authorization'] = token ? 'Bearer ' + token : '';
    }
    return config;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});


axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    return response;
}, (error) => {

    // // Any status codes that falls outside the range of 2xx cause this function to trigger
    // // Do something with response error

    const { response, config } = error;
    const refreshToken = getLocalData('refreshToken');
    const canRefresh = response && response.status === 401 && config && !config._retry
        && !config.skipAuth && refreshToken;
    if (!canRefresh) {
        return Promise.reject(error);
    }

    config._retry = true;
    if (!refreshPromise) {
        refreshPromise = axios.post('customer/token/refresh', { refreshToken }, { skipAuth: true })
            .then(result => {
                setLocalData('token', result.data.token);
                setLocalData('refreshToken', result.data.refreshToken);
                return result.data.token;
            })
            .catch(refreshError => {
                removeLocalData('token');
                removeLocalData('refreshToken');
                throw refreshError;
            })
            .finally(() => {
                refreshPromise = null;
            });
    }
    return refreshPromise.then(token => {
        config.headers.Authorization = 'Bearer ' + token;
        return axios(config);
    });
});
